module.exports = __webpack_public_path__ + "img/obuchenie.c809e588.svg";